(function () {
  var FADE_OUT_MS = 200;
  var COLLAPSE_MS = 280;

  function openProductTab(block) {
    var content = block.querySelector(".collapsible-content");
    var button = block.querySelector(".collapsible-trigger");
    if (!content || !button) return;

    content.classList.remove("is-closing");
    content.classList.add("is-open");
    button.classList.add("is-open");
    button.setAttribute("aria-expanded", "true");
    content.dataset.tabAnimating = "false";
  }

  function closeProductTabInstant(block) {
    var content = block.querySelector(".collapsible-content");
    var button = block.querySelector(".collapsible-trigger");
    if (!content || !button) return;

    content.classList.remove("is-open", "is-closing");
    button.classList.remove("is-open");
    button.setAttribute("aria-expanded", "false");
    content.dataset.tabAnimating = "false";
  }

  function closeProductTabAnimated(block) {
    var content = block.querySelector(".collapsible-content");
    var button = block.querySelector(".collapsible-trigger");
    var inner = content && content.querySelector(".collapsible-content__inner");
    if (!content || !button || !inner) return;
    if (content.dataset.tabAnimating === "true") return;
    if (!content.classList.contains("is-open")) return;

    content.dataset.tabAnimating = "true";
    button.classList.remove("is-open");
    button.setAttribute("aria-expanded", "false");
    content.classList.add("is-closing");

    var collapseStarted = false;

    function collapseTab() {
      if (collapseStarted) return;
      collapseStarted = true;
      content.classList.remove("is-open");

      var collapseDone = false;

      function finishCollapse() {
        if (collapseDone) return;
        collapseDone = true;
        content.removeEventListener("transitionend", onCollapse);
        content.classList.remove("is-closing");
        content.dataset.tabAnimating = "false";
      }

      function onCollapse(event) {
        if (event.target !== content || event.propertyName !== "grid-template-rows") return;
        finishCollapse();
      }

      content.addEventListener("transitionend", onCollapse);
      window.setTimeout(finishCollapse, COLLAPSE_MS + 50);
    }

    function onFadeOut(event) {
      if (event.target !== inner || event.propertyName !== "opacity") return;
      inner.removeEventListener("transitionend", onFadeOut);
      collapseTab();
    }

    inner.addEventListener("transitionend", onFadeOut);
    window.setTimeout(function () {
      inner.removeEventListener("transitionend", onFadeOut);
      collapseTab();
    }, FADE_OUT_MS + 50);
  }

  function openProductTabBlock(block) {
    openProductTab(block);
  }

  window.openProductTabBlock = openProductTabBlock;

  function toggleProductTab(button) {
    var block = button.closest(".product-block--tab");
    if (!block) return;

    var content = block.querySelector(".collapsible-content");
    if (!content || content.dataset.tabAnimating === "true") return;

    if (content.classList.contains("is-open")) {
      closeProductTabAnimated(block);
      return;
    }

    openProductTab(block);
  }

  function initProductTabsClosed(skipNewsletter) {
    document.querySelectorAll(".product-block--tab").forEach(function (block) {
      if (skipNewsletter && block.querySelector(".product-discount-newsletter")) {
        return;
      }
      closeProductTabInstant(block);
    });
  }

  function unbindThemeCollapsibles(scope) {
    var root = scope || document;
    root.querySelectorAll(".product-block--tab .collapsible-trigger").forEach(function (trigger) {
      if (typeof trigger.off === "function") {
        trigger.off("click.collapsible");
      }
    });
  }

  function handleProductTabToggle(event) {
    var button = event.target.closest(".collapsible-trigger");
    if (!button || !button.closest(".product-block--tab")) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    toggleProductTab(button);
  }

  document.addEventListener("click", handleProductTabToggle, true);

  function bootProductTabs(scope) {
    var params = new URLSearchParams(window.location.search);
    var keepNewsletterOpen =
      params.has("discount_newsletter") ||
      params.has("customer_posted") ||
      params.has("form_type");

    unbindThemeCollapsibles(scope);
    initProductTabsClosed(keepNewsletterOpen);
  }

  function scheduleBootProductTabs(scope) {
    bootProductTabs(scope);
    window.requestAnimationFrame(function () {
      bootProductTabs(scope);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      scheduleBootProductTabs();
    });
  } else {
    scheduleBootProductTabs();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (event.target && event.target.querySelector(".product-block--tab")) {
      scheduleBootProductTabs(event.target);
    }
  });
})();
